import { render } from "./MoatMapLabels.vue?vue&type=template&id=02c686a0"
import script from "./MoatMapLabels.vue?vue&type=script&lang=js"
export * from "./MoatMapLabels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__